function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import ApiConstants from 'invision-core/src/api/constants';
export var FETCH_PRODUCT_SERVICE_RELATIONSHIPS = {
  BEGIN: 'FETCH_PRODUCT_SERVICE_RELATIONSHIPS_BEGIN',
  SUCCESS: 'FETCH_PRODUCT_SERVICE_RELATIONSHIPS_SUCCESS',
  FAILURE: 'FETCH_PRODUCT_SERVICE_RELATIONSHIPS_FAILURE'
};
export var fetchSubscriberProductServiceRelationshipsPromise = function fetchSubscriberProductServiceRelationshipsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, Object.values(FETCH_PRODUCT_SERVICE_RELATIONSHIPS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberProductServiceRelationships',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var fetchSubscriberProductServiceRelationships = function fetchSubscriberProductServiceRelationships(customerId) {
  return function (dispatch) {
    return fetchSubscriberProductServiceRelationshipsPromise(dispatch, customerId);
  };
};
export var UPDATE_PRODUCT_SERVICE_RELATIONSHIPS = {
  BEGIN: 'UPDATE_PRODUCT_SERVICE_RELATIONSHIPS_BEGIN',
  SUCCESS: 'UPDATE_PRODUCT_SERVICE_RELATIONSHIPS_SUCCESS',
  FAILURE: 'UPDATE_PRODUCT_SERVICE_RELATIONSHIPS_FAILURE'
};
export var updateSubscriberProductServiceRelationshipsPromise = function updateSubscriberProductServiceRelationshipsPromise(dispatch, customerId) {
  var productServiceRelationships = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return ThunkHelper(dispatch, Object.values(UPDATE_PRODUCT_SERVICE_RELATIONSHIPS), {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriberProductServiceRelationships',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ConsumerPlans: productServiceRelationships
    }
  });
};
export var updateSubscriberProductServiceRelationships = function updateSubscriberProductServiceRelationships(customerId) {
  var productServiceRelationships = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch) {
    return updateSubscriberProductServiceRelationshipsPromise(dispatch, customerId, productServiceRelationships);
  };
};